import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueRouter from 'vue-router'
import 'ant-design-vue/dist/antd.less'
import vuescroll from "vuescroll"
import "babel-polyfill"
import uploader from 'vue-simple-uploader'
import CodeEditor from 'bin-code-editor';
import * as echarts from 'echarts';
import 'default-passive-events'
import { ipc, isEE } from '@/utils/ipcRenderer'
import {
  Layout,
  Menu,
  Icon,
  message,
  notification,
  Breadcrumb,
  Dropdown,
  Avatar,
  Modal,
  FormModel,
  Input,
  Col,
  Row,
  Checkbox,
  Button,
  Alert,
  Divider,
  Card,
  Radio,
  Select,
  List,
  DatePicker,
  Switch,
  Table,
  Form,
  Carousel,
  Spin,
  Progress,
  Upload,
  Pagination,
  Tree,
  Drawer,
  Tag,
  Result,
  Tabs,
  Popover, Tooltip,
  InputNumber,
} from 'ant-design-vue'

import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import VueViewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import hevueImgPreview from 'hevue-img-preview'

Vue.prototype.$ipc = ipc
Vue.prototype.$isEE = isEE


Vue.config.productionTip = false

Vue.use(Layout)
  .use(Menu)
  .use(Icon)
  .use(Breadcrumb)
  .use(Dropdown)
  .use(Avatar)
  .use(Modal)
  .use(FormModel)
  .use(Input)
  .use(Col)
  .use(Checkbox)
  .use(Button)
  .use(Alert)
  .use(Row)
  .use(Divider)
  .use(Card)
  .use(Radio)
  .use(Select)
  .use(List)
  .use(DatePicker)
  .use(Switch)
  .use(Table)
  .use(Carousel)
  .use(Form)
  .use(Spin)
  .use(Progress)
  .use(Upload)
  .use(vuescroll)
  .use(Pagination)
  .use(Tree)
  .use(uploader)
  .use(Drawer)
  .use(Tag)
  .use(Result)
  .use(Tabs)
  .use(CodeEditor)
  .use(preview)
  .use(VueViewer)
  .use(Popover)
  .use(InputNumber).use(Tooltip)
  .use(VueDirectiveImagePreviewer, {
    zIndex: '2019' /*弹框的图片级别设置高点 才能在最上层 看的到 更多参数见文档*/
  }).use(hevueImgPreview);


const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.prototype.$message = message
Vue.prototype.$notification = notification
Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$warning = Modal.warning
Vue.prototype.$error = Modal.error
Vue.prototype.$echarts = echarts
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')